/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiDateRangeCalendarOverrides to make it match the design system.
 *
 * See: https://mui.com/x/api/date-pickers/date-range-calendar/#classes
 */ export const MuiDateRangeCalendar = {
    defaultProps: {
        dayOfWeekFormatter: (day)=>day.slice(0, 2),
        showDaysOutsideCurrentMonth: true,
        calendars: 1
    },
    styleOverrides: {
        root: {
            // height needs to account for up to 6 calendar week rows
            ['.MuiPickersSlideTransition-root']: {
                minHeight: '200px'
            }
        }
    }
};

//# sourceMappingURL=date-range-calendar-overrides.js.map